import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FaCaretDown } from 'react-icons/fa';
import RichTextRenderer from 'components/RichTextRenderer';
import Section from './components/Section';
import Addon from './components/Addon';
import { useSearchContext } from '../../hooks/useSearch';
import useSearchMatches from '../../hooks/useSearchMatches';
import useSearchHighlight from '../../hooks/useSearchHighlight';
import { StyledQAItem, Answer } from './styled';

const QAItem = ({ question, answer, sections, isOpen, ...props }) => {
  const { debouncedSearch: search } = useSearchContext();
  const { isSearchMatch } = useSearchMatches(
    useMemo(() => [question, answer, sections], [question, answer, sections])
  );
  const [ref, highlight] = useSearchHighlight();
  const [showAnswer, setShowAnswer] = useState(isOpen || true);

  // TODO: move this to context
  useEffect(() => {
    if (!search) {
      // this is done in order to re-calculate the positions of each page nav link
      // whenever a question is toggled, so that the currently active navlink
      // can be shown correctly
      window.dispatchEvent(new Event('policy-item-toggle'));
    }
  }, [showAnswer, search]);

  useEffect(() => {
    if (search) {
      setShowAnswer(true);
      highlight();
    }
  }, [search, highlight]);

  if (!isSearchMatch) {
    return null;
  }

  return (
    <StyledQAItem showAnswer={showAnswer} ref={ref} key={search} {...props}>
      <h4 onClick={() => setShowAnswer(!showAnswer)}>
        <FaCaretDown />
        {question}
      </h4>
      <Answer showAnswer={showAnswer}>
        <RichTextRenderer richText={answer} />
        {sections?.map((section, i) => {
          if (section.sys.contentType.sys.id === 'policyAddOn') {
            return <Addon key={i} addon={section} />;
          }
          return <Section key={i} section={section} />;
        })}
      </Answer>
    </StyledQAItem>
  );
};

QAItem.propTypes = {
  question: PropTypes.string.isRequired,
  search: PropTypes.string,
  answer: PropTypes.object.isRequired,
  sections: PropTypes.array,
  isOpen: PropTypes.bool
};

export default QAItem;
